export function getExcelData(data) {
  //   data:  list of [    {
  //     "id": 145693,
  //     "email": "sguevara@farcovetsa.com",
  //     "name": "Stephanie",
  //     "lastName": "Guevara",
  //     "active": 1,
  //     "company": {
  //         "id": 133577,
  //         "code": "FARC",
  //         "name": "FARCOVET",
  //         "representative": "Franklin Íñiguez",
  //         "telephone": "(04) 606-0800"
  //     },
  //     "companyId": 133577,
  //     "roles": [
  //         {
  //             "id": 3,
  //             "role": "REPORT",
  //             "description": "Reportes"
  //         },
  //         {
  //             "id": 2,
  //             "role": "USER",
  //             "description": "Usuario"
  //         }
  //     ],
  //     "tokenAutentication": "5356"
  // }]
  let rows = [];
  data.forEach((elem, index) => {
    var _known = {
      Numero: index + 1,
      Email: elem.email,
      Nombre: elem.name,
      Apellidos: elem.lastName,
      Empresa: elem.company.name,
      Roles: elem.roles?.length
        ? elem.roles.map((role) => role.role).join(', ')
        : 'Sin roles',
      Activo: elem.active === 1 ? "Si" : "No",
    };
    rows.push(_known);
  });
  return rows;
}
